<template>
  <EarlyAccessBanner>
    <template #text>
      <div class="early-access-cta__text">
        <p class="early-access-cta__title">
          Congratulations - you have early access to our new Podcast guides!
        </p>
        <p class="early-access-cta__subtitle">
          We have big plans, so please suggest podcasts and
          <router-link :to="{ name: 'help' }">report problems here</router-link>
          or email
          <a href="mailto:help@shortform.com">help@shortform.com</a>
        </p>
      </div>
    </template>
  </EarlyAccessBanner>
</template>

<script setup lang="ts">
import EarlyAccessBanner from '@/app/components/doc/EarlyAccessBanner.vue'
</script>
